import React, { useState, useEffect, useRef } from 'react';

const GroupDropdown = ({ options = [], value = [], onSelectionChange }) => {
  const [selectedOption, setSelectedOption] = useState(value);
  const previousOptionsRef = useRef(options);

  const serializeValue = (optionValue) =>
    JSON.stringify(optionValue === undefined ? [] : optionValue);

  useEffect(() => {
    const previousOptions = previousOptionsRef.current;
    const optionsChanged =
      JSON.stringify(previousOptions) !== JSON.stringify(options);

    if (optionsChanged) {
      previousOptionsRef.current = options;

      const valueExists = options.some(
        (opt) => JSON.stringify(opt.value) === JSON.stringify(value)
      );

      if (valueExists) {
        setSelectedOption(value);
      } else if (options.length > 0) {
        const defaultValue = options[0].value;
        setSelectedOption(defaultValue);
        onSelectionChange(defaultValue);
      } else {
        setSelectedOption([]);
      }
    }
  }, [options, value, onSelectionChange]);

  useEffect(() => {
    if (JSON.stringify(value) !== JSON.stringify(selectedOption)) {
      setSelectedOption(value);
    }
  }, [value, selectedOption]);

  const handleSelectChange = (event) => {
    try {
      const newValue = JSON.parse(event.target.value);
      setSelectedOption(newValue);
      onSelectionChange(newValue);
    } catch (error) {
      setSelectedOption([]);
      onSelectionChange([]);
    }
  };

  return (
    <div className="custom-class-selection">
      <select
        value={serializeValue(selectedOption)}
        onChange={handleSelectChange}
        className="custom-select"
      >
        {options.map((option, index) => (
          <option key={index} value={serializeValue(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GroupDropdown;
